<section>
  <div id="loginBox">
    <h1>Hallo!</h1>
    <p>
      Dies ist eine Webseite für die ostfriesische Familie Kempe und ihre
      Verwandten. Da hier der Familienstammbaum hinterlegt ist, dürfen nur
      verifizierte Familienmitglieder darauf zugreifen. Für die Registrierung
      braucht ihr die Empfehlung eines bereits registrierten, uns bekannten
      Nutzers oder müsst euch anderweitig ausweisen.
      <br />
      <br /><b
        >Noch ein Hinweis: Diese Seite läuft über ein sicheres, aber
        kostengünstiges Backend. Der Nachteil ist, dass dies recht langsam ist.
        Dadurch kann es zu Fehlern kommen - manchmal muss man es leider etwas
        öfter probieren oder die Seite neu laden.</b
      >
      <br />
      <b
        >Die Probleme mit dem iPhones sollten behoben sein - wenn nicht, bitte
        informiert Anne!</b
      >
    </p>
    <p>Hier geht es zur <a routerLink="/register">Registrierung!</a></p>
    <h3>Schon registriert? Hier ist der Login:</h3>
    <form #form="ngForm" (ngSubmit)="login()">
      <input
        required
        name="email"
        [(ngModel)]="email"
        id="email"
        placeholder="Emailadresse"
      />
      <div class="passwordContainer">
        <input
          required
          [type]="passwordVisible ? 'text' : 'password'"
          name="password"
          [(ngModel)]="password"
          id="password"
          placeholder="Passwort"
        />
        <div
          type="button"
          (click)="togglePasswordVisibility()"
          class="togglePassword"
        >
          @if (passwordVisible) {
            <span>👁️</span>
          }
          @if (!passwordVisible) {
            <span>🙈</span>
          }
        </div>
      </div>
      @if (errorMessage) { <p class="errorMessage">{{ errorMessage }}</p>}
      
      <button type="submit" [disabled]="!form.valid">Einloggen</button>
    </form>

    <a class="center" routerLink="/forgot">Passwort vergessen?</a>
  </div>
</section>
